"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserCheck: function() {
        return UserCheck;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserCheck = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6ZM4.06189 21C4.55399 17.0537 7.92038 14 12 14C14.2868 14 16.3482 14.9582 17.8074 16.4978C18.1874 16.8987 18.8203 16.9156 19.2211 16.5357C19.622 16.1558 19.639 15.5229 19.259 15.122C17.4378 13.2005 14.8583 12 12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H12.5348C13.087 23 13.5348 22.5523 13.5348 22C13.5348 21.4477 13.087 21 12.5348 21H4.06189ZM22.7071 17.2929C23.0976 17.6834 23.0976 18.3166 22.7071 18.7071L18.7071 22.7071C18.3166 23.0976 17.6834 23.0976 17.2929 22.7071L15.2929 20.7071C14.9024 20.3166 14.9024 19.6834 15.2929 19.2929C15.6834 18.9024 16.3166 18.9024 16.7071 19.2929L18 20.5858L21.2929 17.2929C21.6834 16.9024 22.3166 16.9024 22.7071 17.2929Z",
        fill: "currentColor"
    })
}), "UserCheck");
const _default = UserCheck;
